import React, { Component } from "react";
import { Link } from "react-router";

import Logo from "../../../components/header/logo_white.png";
import Calendar from "./assets/cal.png";
import CalendarItem from "./assets/calendar.png";
import ContractItem from "./assets/contract.png";
import ContactItem from "./assets/contacts.png";
import InvoiceItem from "./assets/invoice.png";
import PublishItem from "./assets/publish.png";
import MobileItem from "./assets/mobile.png";
import AppStore from "./assets/app_store.png";
import PlayStore from "./assets/play_store.png";

import "./assets/style.scss";

export default class Influencers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scroll: 0,
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll, true);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const element = document.getElementsByClassName("aboss__influencers");
    this.setState({
      scroll: element[0].getBoundingClientRect().top,
    });
  };

  render() {
    return (
      <div className="aboss__influencers">
        <div className="aboss__influencers-hero">
          <h1>
            ABOSS<span>Influencers</span>
          </h1>
          <p>
            ABOSS helps you manage your day to day career as an influencer. We
            bring together everything that’s required to manage your day to day
            schedule, automate administrative tasks and assist you to gain
            insights into your history to perform better tommorow.
          </p>
          <Link to="/trial">
            <button>Start trial</button>
          </Link>
          <p>
            <span>
              <Link to="/products/agency">
                Looking to manage multiple calendars?
              </Link>
            </span>
          </p>
          <div className="aboss__influencers-hero-image-one"></div>
          <div
            className="aboss__influencers-hero-image-two"
            style={{ marginTop: this.state.scroll / 5 }}
          ></div>
        </div>

        <div className="aboss__influencers-icons">
          <div>
            <a href="#block-one">
              <div className="aboss__influencers-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
              </div>
              <span>Calendar</span>
            </a>
          </div>
          {/* <div>
            <a href="#block-two">
              <div className="aboss__influencers-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                  <polyline points="10 9 9 9 8 9"></polyline>
                </svg>
              </div>
              <span>Contracts</span>
            </a>
          </div> */}
          <div>
            <a href="#block-two">
              <div className="aboss__influencers-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
              <span>Contacts</span>
            </a>
          </div>
          <div>
            <a href="#block-three">
              <div className="aboss__influencers-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                </svg>
              </div>
              <span>Invoices</span>
            </a>
          </div>
          <div>
            <a href="#block-five">
              <div className="aboss__influencers-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="16 18 22 12 16 6"></polyline>
                  <polyline points="8 6 2 12 8 18"></polyline>
                </svg>
              </div>
              <span>Publish</span>
            </a>
          </div>
          <div>
            <a href="#block-mobile">
              <div className="aboss__influencers-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
                  <line x1="12" y1="18" x2="12.01" y2="18"></line>
                </svg>
              </div>
              <span>Mobile App</span>
            </a>
          </div>
        </div>

        <div className="aboss__influencers-blocks">
          <div className="aboss__influencers-blocks-block" id="block-one">
            <div>
              <img src={CalendarItem} />
            </div>
            <div>
              <div className="aboss__influencers-blocks-block-content">
                <h2>Calendar</h2>
                <h1>
                  Schedule & organise all releases, posts and meet & greets in a
                  single calendar
                </h1>
                <div>
                  <p>
                    Your ABOSS calendar is built specifically for your day to
                    day activities. Manage all your upcoming todo's and
                    meetings, schedule all upcoming posts, releases and organise
                    your own live performances and meet & greets. Built
                    especially for creatives, the calendar offers additional
                    features to create your deals, generate invoices and connect
                    your clients to each relevant event or meeting. You can
                    connect the calendar with your external software tools like
                    iCal or Google Calendar and always stay connected through
                    the mobile app.
                  </p>
                  <ul>
                    <li>
                      <span>Social media posts</span>
                    </li>
                    <li>
                      <span>Meet & greets</span>
                    </li>
                    <li>
                      <span>Meetings</span>
                    </li>
                    <li>
                      <span>Live performances</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="aboss__influencers-blocks-block" id="block-two">
            <div>
              <img src={ContractItem} />
            </div>
            <div>
              <div className="aboss__influencers-blocks-block-content">
                <h2>Contracts</h2>
                <h1>Generate the contracts for your brand partnerships</h1>
                <p>
                  Nulla efficitur blandit massa id elementum. Morbi augue
                  sapien, blandit sodales nisi vitae, tincidunt malesuada diam.
                  Duis vitae odio rutrum, bibendum turpis vitae, blandit lacus.
                  Phasellus euismod enim vel mi hendrerit molestie. Phasellus
                  consectetur tincidunt neque. Proin enim diam, facilisis id
                  convallis blandit, blandit ut nunc. Mauris at leo porttitor,
                  tincidunt urna eu, accumsan leo. Vivamus in vehicula metus.
                  Pellentesque sit amet sapien nulla. Sed accumsan quam sed
                  pharetra viverra. Sed consectetur porta tincidunt. Suspendisse
                  in lobortis ipsum. Vivamus pulvinar ligula et sapien ultricies
                  bibendum. Aenean nisi neque, mattis at lorem in, congue
                  ultrices ex. Donec et semper lacus. Donec at dolor
                  consectetur, elementum urna a, pharetra erat.
                </p>
              </div>
            </div>
          </div> */}

          <div className="aboss__influencers-blocks-block" id="block-two">
            <div>
              <img src={ContactItem} />
            </div>
            <div>
              <div className="aboss__influencers-blocks-block-content">
                <h2>Contacts</h2>
                <h1>Track all your relations and know their history</h1>
                <p>
                  Manage all your contacts you interact with and built up your
                  personal history for each of your contacts. See when you've
                  worked with them before, manage contact information and
                  validate businesses in Europe with our VAT number check.
                  {/* Nulla efficitur blandit massa id elementum. Morbi augue
                  sapien, blandit sodales nisi vitae, tincidunt malesuada diam.
                  Duis vitae odio rutrum, bibendum turpis vitae, blandit lacus.
                  Phasellus euismod enim vel mi hendrerit molestie. Phasellus
                  consectetur tincidunt neque. Proin enim diam, facilisis id
                  convallis blandit, blandit ut nunc. Mauris at leo porttitor,
                  tincidunt urna eu, accumsan leo. Vivamus in vehicula metus.
                  Pellentesque sit amet sapien nulla. Sed accumsan quam sed
                  pharetra viverra. Sed consectetur porta tincidunt. Suspendisse
                  in lobortis ipsum. Vivamus pulvinar ligula et sapien ultricies
                  bibendum. Aenean nisi neque, mattis at lorem in, congue
                  ultrices ex. Donec et semper lacus. Donec at dolor
                  consectetur, elementum urna a, pharetra erat. */}
                </p>
              </div>
            </div>
          </div>

          {/* <div className="aboss__influencers-blocks-block" id="block-three">
            <div>
              <img src={ContactItem} />
            </div>
            <div>
              <div className="aboss__influencers-blocks-block-content">
                <h2>Contacts</h2>
                <h1>Track all your relations and know their history</h1>
                <p>
                  Nulla efficitur blandit massa id elementum. Morbi augue
                  sapien, blandit sodales nisi vitae, tincidunt malesuada diam.
                  Duis vitae odio rutrum, bibendum turpis vitae, blandit lacus.
                  Phasellus euismod enim vel mi hendrerit molestie. Phasellus
                  consectetur tincidunt neque. Proin enim diam, facilisis id
                  convallis blandit, blandit ut nunc. Mauris at leo porttitor,
                  tincidunt urna eu, accumsan leo. Vivamus in vehicula metus.
                  Pellentesque sit amet sapien nulla. Sed accumsan quam sed
                  pharetra viverra. Sed consectetur porta tincidunt. Suspendisse
                  in lobortis ipsum. Vivamus pulvinar ligula et sapien ultricies
                  bibendum. Aenean nisi neque, mattis at lorem in, congue
                  ultrices ex. Donec et semper lacus. Donec at dolor
                  consectetur, elementum urna a, pharetra erat.
                </p>
              </div>
            </div>
          </div> */}

          <div className="aboss__influencers-blocks-block" id="block-three">
            <div>
              <img src={InvoiceItem} />
            </div>
            <div>
              <div className="aboss__influencers-blocks-block-content">
                <h2>Invoices</h2>
                <h1>Generate your invoices and track payments</h1>
                <p>
                  ABOSS lets you generate, send and track the payment status of
                  invoices directly from the system. Generate general invoices
                  by adding the invoice posts manually or let ABOSS
                  automatically generate them based on event deals. Track the
                  status of each invoice based on the invoice itself or generate
                  an overview of all upcoming events and track the payment
                  status of each of them. Export your invoice data and PDF's for
                  your accountant with a single click or request a customised
                  integration with us to integrate with your accountant
                  software.
                  {/* Nulla efficitur blandit massa id elementum. Morbi augue
                  sapien, blandit sodales nisi vitae, tincidunt malesuada diam.
                  Duis vitae odio rutrum, bibendum turpis vitae, blandit lacus.
                  Phasellus euismod enim vel mi hendrerit molestie. Phasellus
                  consectetur tincidunt neque. Proin enim diam, facilisis id
                  convallis blandit, blandit ut nunc. Mauris at leo porttitor,
                  tincidunt urna eu, accumsan leo. Vivamus in vehicula metus.
                  Pellentesque sit amet sapien nulla. Sed accumsan quam sed
                  pharetra viverra. Sed consectetur porta tincidunt. Suspendisse
                  in lobortis ipsum. Vivamus pulvinar ligula et sapien ultricies
                  bibendum. Aenean nisi neque, mattis at lorem in, congue
                  ultrices ex. Donec et semper lacus. Donec at dolor
                  consectetur, elementum urna a, pharetra erat. */}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="aboss__influencers-cta">
          <div>
            <div className="aboss__influencers-cta-content">
              <h1>Start your free trial today</h1>
              <Link to="/trial">
                <button>Start trial</button>
              </Link>
              <ul>
                <li>Free for 14 days</li>
                <li>No credit card needed</li>
              </ul>
            </div>
          </div>
          <div></div>
        </div> */}

        <div className="aboss__influencers-blocks-blocks">
          {/* <div className="aboss__influencers-blocks-block" id="block-four">
            <div>
              <img src={InvoiceItem} />
            </div>
            <div>
              <div className="aboss__influencers-blocks-block-content">
                <h2>Invoices</h2>
                <h1>Generate your invoices and track payments</h1>
                <p>
                  Nulla efficitur blandit massa id elementum. Morbi augue
                  sapien, blandit sodales nisi vitae, tincidunt malesuada diam.
                  Duis vitae odio rutrum, bibendum turpis vitae, blandit lacus.
                  Phasellus euismod enim vel mi hendrerit molestie. Phasellus
                  consectetur tincidunt neque. Proin enim diam, facilisis id
                  convallis blandit, blandit ut nunc. Mauris at leo porttitor,
                  tincidunt urna eu, accumsan leo. Vivamus in vehicula metus.
                  Pellentesque sit amet sapien nulla. Sed accumsan quam sed
                  pharetra viverra. Sed consectetur porta tincidunt. Suspendisse
                  in lobortis ipsum. Vivamus pulvinar ligula et sapien ultricies
                  bibendum. Aenean nisi neque, mattis at lorem in, congue
                  ultrices ex. Donec et semper lacus. Donec at dolor
                  consectetur, elementum urna a, pharetra erat.
                </p>
              </div>
            </div>
          </div> */}

          <div className="aboss__influencers-blocks-block" id="block-five">
            <div>
              <img src={PublishItem} />
            </div>
            <div>
              <div className="aboss__influencers-blocks-block-content">
                <h2>Publish</h2>
                <h1>
                  Update your social media and website with upcoming events
                </h1>
                <p>
                  Link your calendar to your Facebook page and website to
                  automatically display upcoming public events to your fans. We
                  offer an integration for Facebook, Wordpress and have an
                  advanced API available to fully customise the integration to
                  display the events the way you'd like.
                </p>
              </div>
            </div>
          </div>

          {/* <div className="aboss__influencers-blocks-block" id="block-five">
            <div>
              <img src={PublishItem} />
            </div>
            <div>
              <div className="aboss__influencers-blocks-block-content">
                <h2>Publish</h2>
                <h1>
                  Update your social media and website with upcoming events
                </h1>
                <p>
                  Nulla efficitur blandit massa id elementum. Morbi augue
                  sapien, blandit sodales nisi vitae, tincidunt malesuada diam.
                  Duis vitae odio rutrum, bibendum turpis vitae, blandit lacus.
                  Phasellus euismod enim vel mi hendrerit molestie. Phasellus
                  consectetur tincidunt neque. Proin enim diam, facilisis id
                  convallis blandit, blandit ut nunc. Mauris at leo porttitor,
                  tincidunt urna eu, accumsan leo. Vivamus in vehicula metus.
                  Pellentesque sit amet sapien nulla. Sed accumsan quam sed
                  pharetra viverra. Sed consectetur porta tincidunt. Suspendisse
                  in lobortis ipsum. Vivamus pulvinar ligula et sapien ultricies
                  bibendum. Aenean nisi neque, mattis at lorem in, congue
                  ultrices ex. Donec et semper lacus. Donec at dolor
                  consectetur, elementum urna a, pharetra erat.
                  <br />
                  <br />
                  Link your calendar to your Facebook page and website to
                  automatically display upcoming public events to your fans. We
                  offer an integration for Facebook, Wordpress and have an
                  advanced API available to fully customise the integration to
                  display the events the way you'd like.
                </p>
              </div>
            </div>
          </div>*/}

          <div className="aboss__influencers-blocks-block" id="block-mobile">
            <div>
              <img src={MobileItem} />
            </div>
            <div>
              <div className="aboss__influencers-blocks-block-content">
                <h2>Mobile App</h2>
                <h1>All information available in your pocket</h1>
                <div className="aboss__influencers-blocks-block-content-store">
                  <a href="https://itunes.apple.com/us/app/aboss/id1048993502?ls=1&mt=8">
                    <img src={AppStore} className="appstore" />
                  </a>
                  <a href="https://play.google.com/store/apps/details?id=com.aboss">
                    <img src={PlayStore} className="playstore" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="aboss__influencers-footer">
          <div></div>
          <div>
            <h1>Start your free trial today</h1>
            <a href="https://abossmusic.com/artist/trial">
              <button>Start trial</button>
            </a>
            <ul>
              <li>Free for 14 days</li>
              <li>No credit card needed</li>
            </ul>
          </div>
          <div></div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/views/cases/influencers/index.js